import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotDisplayRappidDiamondPot } from "./JackpotDisplayRappidDiamondPot";
import { Scale, Size } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope } from "./ScreenProtocol";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
export class JackpotDisplayRapidLinkDiamondPotFire extends  JackpotDisplayRappidDiamondPot {	
	public constructor(params: JackpotDisplayParams) {
		super(params);
		// this.resid = params.resid.Add("JackpotDisplayRapidLinkDiamondPotStep");
		// this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayRapidLinkDiamondPotStep");
		// this.view.classList.add(this.resid.ID());
	}

	
}